import React from 'react';
import PropTypes from 'prop-types';

export function SvgCoins(props) {
  const { width = 19, height = 14, stroke = '#000' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 19 14">
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill={stroke} fillRule="nonzero" transform="translate(-339 -496)">
          <g transform="translate(259 386)">
            <g transform="translate(27 104)">
              <g transform="translate(38)">
                <g transform="translate(12 1)">
                  <path d="M3.025 7.236v-.535C3.025 5.753 5.521 5 8.63 5c3.081 0 5.603.753 5.603 1.701v.535c0 .948-2.496 1.702-5.603 1.702-3.108 0-5.604-.754-5.604-1.702zm5.578 8.969c.535 0 1.044-.024 1.528-.073v-1.798c-.484.048-1.018.072-1.528.072-1.553 0-3.03-.194-4.151-.534a7.574 7.574 0 01-1.146-.462c-.204.17-.306.364-.306.559v.534c.025.948 2.521 1.702 5.603 1.702zm0-4.861c.611 0 1.172-.025 1.732-.073.255-.39.79-.827 1.885-1.143.586-.17 1.248-.316 1.986-.388v-.608c0-.194-.101-.389-.305-.56-.28.171-.662.317-1.146.463-1.121.34-2.598.534-4.152.534-1.553 0-3.03-.194-4.151-.534a7.574 7.574 0 01-1.146-.462c-.204.17-.306.364-.306.559v.535c.025.923 2.521 1.677 5.603 1.677zm0 2.43c.535 0 1.044-.024 1.528-.073v-1.774c-.484.049-1.018.073-1.528.073-1.553 0-3.03-.194-4.151-.535a7.574 7.574 0 01-1.146-.462c-.204.17-.306.365-.306.56v.534c.025.924 2.521 1.677 5.603 1.677zm13.372 1.094v-.535c0-.194-.102-.389-.306-.559-.28.17-.662.316-1.146.462-1.12.34-2.598.535-4.152.535-1.553 0-3.03-.195-4.151-.535-.484-.146-.84-.316-1.146-.462-.204.17-.306.365-.306.56v.534c0 .948 2.496 1.701 5.603 1.701 3.108 0 5.604-.753 5.604-1.7zm-11.181-2.94v.534c0 .948 2.496 1.701 5.603 1.701 3.082 0 5.603-.753 5.603-1.701v-.535c0-.948-2.496-1.701-5.603-1.701-3.107 0-5.603.753-5.603 1.701zm0 5.37c0 .949 2.496 1.702 5.603 1.702C19.479 19 22 18.247 22 17.299v-.535c0-.195-.102-.389-.306-.56-.28.171-.662.317-1.146.463-1.12.34-2.598.534-4.151.534-1.554 0-3.031-.194-4.152-.534-.484-.146-.84-.316-1.146-.462-.204.17-.305.364-.305.559v.535z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

SvgCoins.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
};
